// extracted by mini-css-extract-plugin
module.exports = {"container":"DayHeader_container__1KT_V","day":"DayHeader_day__2mVya"};